<template>
    <!-- 背景图 -->
    <div class="video-bg"></div>

    <div class="main">
        <!--顶部导航栏菜单-->
        <header-component v-if="showPonent === true" ref="header"></header-component>
        <div class="wrapper">
            <!--左边导航栏菜单-->
            <!-- <left-component></left-component> -->
            <!-- 内容区域 -->
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import HeaderComponent from "@/components/HeaderComponent";
    import LeftComponent from "@/components/LeftComponent";
    import Bus from "@/router/bus";
    import { SseService } from "@/utils/sseService.ts";

    import { ElMessage } from "element-plus";

    const debounce = (fn, delay) => {
        let timer = null;
        return function () {
            let context = this;
            let args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    };

    // 解决ERROR ResizeObserver loop completed with undelivered notifications.
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
        constructor(callback) {
            callback = debounce(callback, 16);
            super(callback);
        }
    };

    export default {
        name: "App",
        components: { HeaderComponent, LeftComponent },
        data() {
            return {
                testshow: process.env.VUE_APP_SHOW,
                showPonent: false,
            };
        },
        methods: {},
        mounted() {
            /*eventBus接收传过来的方法 */
            Bus.on("changeMsg", (data) => {
                this.showPonent = data;
            });
            /*sse相关*/
            this.sseService = new SseService();
            this.sseService.connect();
        },
        beforeUnmount() {
            // 关闭sse
            if (this.sseService) {
                this.sseService.close();
            }
        },
        computed: {},
    };
</script>

<style>
    @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700&display=swap");

    #app {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        /*background-color: red;*/
    }

    /*背景*/
    .video-bg {
        background-image: url("@/assets/images/macos-big-sur-1280x720-dark-wwdc-2020-22655.jpg");
        background-size: cover;
        /* 可选：根据需要调整背景大小 */
        background-position: center;
        /* 可选：根据需要调整背景位置 */
        position: fixed;
        right: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    /*主页面*/
    .main {
        background-color: rgba(16 18 27 / 30%);
        height: 90vh;
        height: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: relative;
        width: 100%;
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        font-size: 15px;
        font-weight: 500;
    }

    .wrapper {
        display: flex;
        flex-grow: 1;
        overflow: hidden;
    }

    /* 宽度和高度 */
    ::-webkit-scrollbar {
        /* 滚动条宽度 */
        width: 12px;
        height: 8px;
    }

    /* 轨道 */
    ::-webkit-scrollbar-track {
        /* 滚动条轨道背景色 */
        background: #f1f1f1;
    }

    /* 滑块 */
    ::-webkit-scrollbar-thumb {
        /* 滚动条滑块颜色 */
        background: #888;
    }

    /* 滑块悬停时 */
    ::-webkit-scrollbar-thumb:hover {
        /* 滑块悬停时的颜色 */
        background: #555;
    }
</style>
